/**
 * Ritorna lo stesso numero con i decimali arrotondati.
 *
 * @param {Number} valore
 * @param {Number} [num_decimali] - default: 2
 * @return {number}
 */
Math.roundDecimals = function (valore, num_decimali) {
  num_decimali = num_decimali || 2;

  var fixed_str = Number.parseFloat(valore).toFixed(num_decimali);

  return Number(fixed_str);
};

if (typeof Number.parseFloat === "undefined") {
  Number.parseFloat = parseFloat;
}